import { ReactElement } from 'react';
import { Navigate } from 'react-router-dom';

import { AnalyticsService, useApiEffect } from '@localstack/services';
import { FeatureMaturityLevel, ProductFeature } from '@localstack/types';

import { AppRoute } from '~/config';
import { useAuthProvider } from '~/hooks/useAuthProvider';
import { BasicPageLayout, PageGutter } from '~/layouts';

import { UsageInsightView } from '~/components/UsageInsights';

export const UsageInsights = (): ReactElement => {
  const { hasFeature, isWorkspaceAdmin } = useAuthProvider();
  const hasUsageInsightsAccess = hasFeature(ProductFeature.FEATURE_USAGE_INSIGHTS);
  const { getUsageInsights, isLoading } = useApiEffect(AnalyticsService, ['getUsageInsights']);

  if (!isWorkspaceAdmin || !hasUsageInsightsAccess) {
    return <Navigate replace to={AppRoute.NOT_FOUND} />;
  }

  return (
    <BasicPageLayout
      title="Usage"
      planFamily={FeatureMaturityLevel.PREVIEW}
      subtitle="License activation across your workspace over time."
      variant="full"
    >
      <PageGutter variant="full" sx={{ marginTop: (theme) => theme.spacing(4) }}>
        <UsageInsightView fetchData={getUsageInsights} isLoading={isLoading} />
      </PageGutter>
    </BasicPageLayout>
  );
};
